import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useEmploymentTypeConfig = () => {
    const { t } = useTranslation();

    return useMemo(() => [
        {
            key: "employmentType",
            name: t("employment-type"),
        }
    ], [t]);
}
